import { combineReducers, createStore } from "redux";

import {
  companiesReducer,
  guildRolesReducer,
  insightsReducer,
  messagesReducer,
  teamTagsReducer,
  usersReducer,
} from "./reducers";

const store = createStore(
  combineReducers({
    teamTags: teamTagsReducer,
    users: usersReducer,
    companies: companiesReducer,
    insights: insightsReducer,
    guildRoles: guildRolesReducer,
    messages: messagesReducer,
  })
);

export default store;
